<fieldset>
 <legend>
  TypeOuiNon
 </legend>
 <app-form-input
[parentForm]="parentForm"
[value]="candidatsDejaSelectionnes.oui"

[label]="'oui'"
[type]="'tofix'" [rule]="''"
[name]="getUid()+'_SepAtt_oui'">
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="candidatsDejaSelectionnes.non"

[label]="'non'"
[type]="'tofix'" [rule]="''"
[name]="getUid()+'_SepAtt_non'">
</app-form-input>
</fieldset>
